"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _types = require("../../util/types");

var _OutsideClickWrapper = _interopRequireDefault(require("../OutsideClickWrapper/OutsideClickWrapper"));

var _hooks = require("../../util/hooks");

var _reactstrap = require("reactstrap");

require("./SearchSelectionAgent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var SearchSelectionAgent = function SearchSelectionAgent(_ref) {
  var options = _ref.options,
      noDefault = _ref.noDefault,
      defaultIndex = _ref.defaultIndex,
      disabled = _ref.disabled,
      keyResult = _ref.keyResult,
      filterBy = _ref.filterBy,
      ignoreCase = _ref.ignoreCase,
      onSelected = _ref.onSelected,
      placeholder = _ref.placeholder,
      sort = _ref.sort;

  var _useState = (0, _react.useState)(options),
      _useState2 = _slicedToArray(_useState, 2),
      option = _useState2[0],
      setOption = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(''),
      _useState6 = _slicedToArray(_useState5, 2),
      value = _useState6[0],
      setValue = _useState6[1];

  var _useState7 = (0, _react.useState)(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      selection = _useState8[0],
      setSelection = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isDisplayBySearch = _useState10[0],
      setIsDisplayBySearch = _useState10[1];

  var _useScaledBottomLimit = (0, _hooks.useScaledBottomLimit)(),
      _useScaledBottomLimit2 = _slicedToArray(_useScaledBottomLimit, 2),
      menuRef = _useScaledBottomLimit2[0],
      limit = _useScaledBottomLimit2[1];

  var inputRef = (0, _react.useRef)();
  var filterRef = (0, _react.useRef)(filter);
  var stringifiedData = JSON.stringify(options);
  var tooltipRef = (0, _react.useRef)();

  var toggle = function toggle() {
    return setOpen(!isOpen);
  };

  (0, _react.useEffect)(function () {
    if (noDefault) return;
    var selected = defaultIndex && options[defaultIndex] ? options[defaultIndex] : options[0];
    setSelection(selected);
  }, [JSON.stringify(options)]);
  (0, _react.useEffect)(function () {
    if (isOpen && selection !== undefined) {
      setValue('');
    } else if (!isOpen && selection !== undefined) {
      setValue(selection[filterBy]);
    }
  }, [isOpen]);
  (0, _react.useEffect)(function () {
    filterRef.current();
  }, [value, stringifiedData, isDisplayBySearch]);

  var setState = function setState(inputValue) {
    !isDisplayBySearch && setIsDisplayBySearch(true);

    if (!disabled) {
      if (inputValue.length > 0) setOpen(true);
      setValue(inputValue);

      if (selection !== undefined && inputValue.length === 0) {
        setValue('');
        setSelection(undefined);
      }
    }
  };

  var filter = function filter() {
    var data = Array.isArray(options) ? options : convertDicToArray(options);
    var filteredData = data.filter(arrayFilter);

    if (value === '') {
      setOption(filteredData);
    } else {
      var sortedFilterData = sortData(filteredData);
      ;
      setOption(sortedFilterData);
    }
  };

  filterRef.current = filter;

  var sortData = function sortData(data) {
    if (filterBy && sort && isDisplayBySearch) {
      var temp = data.map(function (element) {
        return element[filterBy];
      }).sort();
      var sortedData = [];
      temp.map(function (t) {
        return data.forEach(function (element) {
          if (element[filterBy] === t) {
            sortedData = [].concat(_toConsumableArray(sortedData), [element]);
          }
        });
      });
      return sortedData;
    }

    return data;
  };

  var convertDicToArray = function convertDicToArray(dic) {
    return Object.keys(dic).map(function (key) {
      var element = dic[key];
      element[keyResult] = key;
      return element;
    });
  };

  var arrayFilter = function arrayFilter(data) {
    if (_typeof(data) === 'object') {
      if (Array.isArray(data)) {
        // array de arrays
        return data.filter(arrayFilter).some(function (x) {
          return x;
        });
      } //array of objects
      else if (filterBy) {
          return searchByKeyIn(data);
        }

      throw new Error("filterBy value wasn't assigned as prop");
    }

    return valueIn(data); //array of string or integers
  };

  var searchByKeyIn = function searchByKeyIn(data) {
    if (Array.isArray(filterBy)) {
      return filterBy.some(function (element) {
        return element in data ? valueIn(data[element]) : false;
      });
    }

    return filterBy in data ? valueIn(data[filterBy]) : false;
  };

  var valueIn = function valueIn(data) {
    var stringData = data.toString();
    return ignoreCase ? stringData.toLowerCase().includes(value.toLowerCase()) : stringData.includes(value);
  };

  (0, _react.useEffect)(function () {
    if (selection) {
      setValue(selection[filterBy]);
      onSelected(selection);
    }
  }, [selection]);

  var handleKeyPress = function handleKeyPress(event) {
    if (event.key === 'Enter') {
      setSelection(option[0]);
      setOpen(false);
    }
  };

  var handleOnBlur = function handleOnBlur() {
    if (value.length === 0) setValue(selection[filterBy]);
  };

  var displayList = function displayList() {
    setIsDisplayBySearch(false);
    !disabled && toggle(isOpen);
  };

  return /*#__PURE__*/_react["default"].createElement(_OutsideClickWrapper["default"], {
    action: function action() {
      return setOpen(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-agent-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-agent ".concat(isOpen ? 'open' : ''),
    ref: tooltipRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-agent-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-agent-body-placeholder"
  }), /*#__PURE__*/_react["default"].createElement("input", {
    ref: inputRef,
    type: "text",
    value: value,
    disabled: disabled,
    onKeyPress: handleKeyPress,
    onBlur: handleOnBlur,
    onChange: function onChange(e) {
      return setState(e.target.value);
    },
    placeholder: placeholder
  })), value.length > 38 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    hideArrow: true,
    target: tooltipRef,
    delay: {
      show: 500,
      hide: 100
    },
    boundariesElement: "window",
    className: "gcl-labelInput-tooltip dispositions"
  }, value), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-search-selection-agent-icon",
    onClick: function onClick() {
      return displayList();
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon triangle'
  }))), isOpen && /*#__PURE__*/_react["default"].createElement("ul", {
    ref: menuRef,
    className: "gcl-search-selection-agent-dropdown-list"
  }, option.map(function (option, i) {
    return /*#__PURE__*/_react["default"].createElement(Option, {
      key: i,
      option: option,
      selection: selection,
      setSelection: setSelection,
      setOpen: setOpen,
      filterBy: filterBy
    });
  }))));
};

var Option = function Option(_ref2) {
  var option = _ref2.option,
      selection = _ref2.selection,
      setSelection = _ref2.setSelection,
      setOpen = _ref2.setOpen,
      filterBy = _ref2.filterBy;
  var refTooltip = (0, _react.useRef)();
  var refTooltipOption = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("li", {
    className: "gcl-dropdown-agent-item ".concat(option === selection ? '--selected' : ''),
    key: option.id,
    onClick: function onClick() {
      setSelection(option);
      setOpen(false);
    },
    ref: refTooltipOption
  }, /*#__PURE__*/_react["default"].createElement("span", null, option[filterBy]), option.icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon ".concat(option.icon),
    ref: refTooltip
  })), option.tooltiptext && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    target: refTooltip,
    autohide: false,
    trigger: 'hover'
  }, option.tooltiptext), option[filterBy].length > 34 && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    placement: "top",
    hideArrow: true,
    target: refTooltipOption,
    delay: {
      show: 500,
      hide: 100
    },
    boundariesElement: "window",
    className: "gcl-labelInput-tooltip dispositions"
  }, option[filterBy]));
};

SearchSelectionAgent.propTypes = {
  disabled: _propTypes["default"].bool,
  options: _propTypes["default"].arrayOf(_types.dropdownType).isRequired,
  filterBy: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]).isRequired,
  //nombre de la(s) propiedade(s) a buscar
  onSelected: _propTypes["default"].func.isRequired,
  sort: _propTypes["default"].bool
};
var _default = SearchSelectionAgent;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/SearchSelectionAgent/SearchSelectionAgent.js
// module id = 1912
// module chunks = 0